module.exports = __webpack_public_path__ + "img/graphics-8.898d9194.svg";